import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroAcordaosEncaminhadosPje extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Acórdão encaminhado ao PJe';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return registro.acordaoTransferido;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }

    get isHabilitado() {
        return this.store.existeSessaoPJe;
    }
}
